import { useTranslation } from 'react-i18next';
import './style.css';

const ServiceContext = ({ data }) => {
    const { t } = useTranslation();

    return (
        <div className="quotation-service-context-section">
            <h2 className="quotation-section-title">{t('service-context')}</h2>

            <div className="quotation-service-context-grid">
                <div className="quotation-service-context-item">
                    <span className="quotation-service-context-label">{t('type')}</span>
                    <p className="quotation-service-context-value">{data?.category || 'Cardiology'}</p>
                </div>

                <div className="quotation-service-context-item">
                    <span className="quotation-service-context-label">{t('subcategory')}</span>
                    <p className="quotation-service-context-value">{data?.subcategory || 'Surgery'}</p>
                </div>
                {/*
            <div className="quotation-service-context-item">
                <span className="quotation-service-context-label">{t('treatment')}</span>
                <p className="quotation-service-context-value">{data?.service || 'Valve Replacement'}</p>
            </div>
                */}

                <div className="quotation-service-context-item">
                    <span className="quotation-service-context-label">{t('request-id')}</span>
                    <p className="quotation-service-context-value quotation-service-context-id">
                        {data?.requestId || 'REQ-98721'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ServiceContext;

